(function (angular) {
	'use strict';

	angular
		.module('forgotPasswordModule')
		.controller('ResetPassword', [
			'$timeout',
			'globalConfig',
			'urlFactory',
			ResetPasswordControllerFunction
		]);

	function ResetPasswordControllerFunction(
		$timeout,
		globalConfig,
		urlFactory
	) {	
		var resetPassword = this;

		resetPassword.$onInit = function() {
			angular.extend(resetPassword, globalConfig);

			if(angular.isDefined(resetPassword.serverSideErrorMap)) {
				$timeout(function() {
					urlFactory.handleServerValidation(
						resetPassword.form,
						urlFactory.spoofApiError(resetPassword.serverSideErrorMap)
					);
				}, 100);
			}
		};
	}
})(window.angular);